import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public.user-accounts', {
        url: '/user-accounts',
        views: {
            '': 'userPublicUserAccounts',
            'header@user': 'userPublicUserAccountsHeader',
        },
        resolve: {authenticators,passwordManagers,publicUserAccounts},
    })
}

/** @ngInject */
function authenticators($filter, Authenticator) {
    return Authenticator.query().$promise
        .then((items) => $filter('orderBy')(items, 'publicService.serviceName'))
        .then((items) => items.map((item) => ({...item, serviceDisplayName: serviceDisplayName(item)})));
}

function serviceDisplayName(authenticator) {
    let displayName = '';
    if (authenticator.customAuthenticator) {
        displayName = authenticator.customAuthenticator.customAuthenticatorName;
    } else {
        displayName = authenticator.publicService.serviceName;
    }
    return displayName;
}

/** @ngInject */
function passwordManagers($filter, PasswordManagers) {
    return PasswordManagers.list()
        .then((items) => $filter('orderBy')(items, 'publicService.serviceName'))
        .then((items) => items.map((item) => ({...item, serviceDisplayName: serviceDisplayName(item)})));
}

/** @ngInject */
function publicUserAccounts(passwordManagers, authenticators) {
    let publicUserAccounts=[];
    Array.prototype.push.apply(publicUserAccounts, authenticators);
    Array.prototype.push.apply(publicUserAccounts, passwordManagers);
    return publicUserAccounts;
}


// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/public-user-accounts.state.js